import { gql } from "@apollo/client";

/**
 * GraphQL Query - Infrastructure layer
 * Defines the query structure for fetching brands list
 */
export const GET_BRANDS = gql`
  query Brands($params: BrandPaginationParamsInput!) {
    brands(params: $params) {
      total
      page
      limit
      items {
        brandId
          brandKey
          brandName
          brandDisplayName
          brandDescription
          brandLogoUrl
          brandIsActive
          brandCreatedAt
          brandUpdatedAt
          brandDeletedAt
          brandCreatedBy
          brandUpdatedBy
          brandDeletedBy
          brandOrganizationId
          brandOrganizationName
      }
    }
  }
`;
